import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { ButtonComponent } from "@components/button/button.component";
import { LabelComponent } from "@components/label/label.component";
import { PageComponent } from "@components/page/page.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { ToggleListItemComponent } from "@components/toggle-list/toggle-list-item/toggle-list-item.component";
import { ToggleListComponent } from "@components/toggle-list/toggle-list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { KundorderTyp } from "~app/common/models/constants";
import { OrderDetailsComponent } from "~app/features/forsaljning/order/order-details/order-details";
import { KundorderradDetailsComponent } from "../../kundorder/kundorder-details/kundorderrad-details/kundorderrad-details.component";
import { KundorderradEditComponent } from "../../kundorder/kundorder-details/kundorderrad-edit/kundorderrad-edit.component";
import { OrderHeaderComponent } from "../../order/order-details/order-header/order-header.component";

@Component({
    selector: "rask-terminalorder-details",
    templateUrl: "./terminalorder-details.component.html",
    styleUrls: ["./terminalorder-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ActionButtonComponent,
        OrderHeaderComponent,
        ToggleListComponent,
        LabelComponent,
        ToggleListItemComponent,
        KundorderradEditComponent,
        KundorderradDetailsComponent,
        ButtonComponent,
        SaveButtonComponent,
        TranslatePipe
    ]
})

export class TerminalorderDetailsComponent extends OrderDetailsComponent {
    kundorderTyp = KundorderTyp.Terminalorder;

    copy = () => {
        this.router.navigate(["copy"], { relativeTo: this.activatedRoute.parent });
    };
}
